<template>
  <div>

    <data-table
      :title="title"
      :icon="'fa fa-' + getIcon(this.category)"
      title-heading="h2"

      table-ref="orgtable"

      :url="'/org' + (this.category ? '?filter=' + this.category  : '')"

      :fields="fields"

      :hide-top="!showTitle"
      :show-search="showSearch"
       sort-field="name"

      :add-action="showAdd() ? addOrg : null"
      :add-props="addProps"

      hide-org-badge
      org-badge-no-full-name

      detail-component="org-detail-row">

      <template #shortName="props">
        <org-badge :organisation="props.rowData" />
      </template>

      <template #subCat="props">
        <i>{{ellipsis(props.rowData.subCategory)}}</i>
      </template>

    </data-table>

  </div>
</template>

<script>

import DateMixins from '@/mixins/DateMixins'
import FormattingMixins from '@/mixins/FormattingMixins'

import Vue from 'vue'

import OrgAction from '@/components/actions/OrgAction'

import OrgControls from '@/components/tables/controls/OrgControls'
import OrgDetail from '@/components/tables/details/OrgDetail'

Vue.component('custom-org-actions', OrgControls)
Vue.component('org-detail-row', OrgDetail)

export default {
  mixins: [DateMixins, FormattingMixins],

  components: {
    OrgAction
  },

  props: {
    category: {
      type: String,
      default: null
    },

    title: {
      type: String,
      default: 'Organisations'
    },

    showTitle: {
      type: Boolean,
      default: true
    },

    showSearch: {
      type: Boolean,
      default: true
    }
  },



  methods: {

    showAdd () {
      return this.localCat && this.localCat === 'Xolas' ? false : true
    },

    getIcon (cat) {

      switch (cat) {

        case 'authority':
          return 'bank'

        case 'backhaul':
          return 'wifi'

        case 'contractor':
          return 'tools'

        case 'landlord':
          return 'house'

        case 'insurer':
          return 'shield-alt'

        case 'telco':
          return 'users'

        case 'tower supplier':
          return 'tower-cell'

        case 'utility':
          return 'plug'

        case 'xolas':
            return 'star'

        default:
          return 'table-columns'
      }

    }
  },



  watch: {

    category: function (value) {
      this.localCat = this.titleCase(value)
      this.addProps.category = this.localCat
    }

  },


  computed: {
    isSubCategoryVisible: function () {

      if (this.localCat) {
        return this.localCat.includes('Contractor')
      }

    return false
    }

  },


  data () {
    return {
      addOrg: OrgAction,
      addProps: {
        category: this.category ? this.category : '',
        isAdd: true
      },
      localCat: this.category,
      telcoId: this.isTelco() ? this.org().id : null,
      fields: [
        {
          name: '__sequence',
          title: '#'
        },
        {
          name: '__slot:shortName',
          title: 'Short Name',
          sortField: 'shortName'
        },
        {
          name: 'name',
          sortField: 'name',
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down',
        },
/*
        {
          name: 'Phone',
          sortField: 'phone',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down',
        },
        {
          name: 'email',
          sortField: 'email',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down',
        },
*/
        {
          title: '# Activities',
          name: 'active'
        },
        {
          title: '# Contacts',
          name: 'contactsCount'
        },
        {
          name: 'category',
          sortField: 'category'
        },
        {
          name: '__slot:subCat',
          title: 'Sub Cat.',
          titleClass: (this.isSubCategoryVisible ? 'hidden-lg-and-down' : 'hidden-md-and-down' ),
          dataClass: (this.isSubCategoryVisible ? 'hidden-lg-and-down' : 'hidden-md-and-down' ),
        },
        {
          name: '__component:custom-org-actions'
        }
      ]
    }
  },

  created () {
    if (this.category) {
      this.localCat = this.titleCase(this.category)
      this.addProps.category = this.localCat
    }
  }
}
</script>
